import { render, staticRenderFns } from "./OpeningBalance.vue?vue&type=template&id=6eb27b19&scoped=true&"
import script from "./OpeningBalance.vue?vue&type=script&lang=js&"
export * from "./OpeningBalance.vue?vue&type=script&lang=js&"
import style0 from "./OpeningBalance.vue?vue&type=style&index=0&id=6eb27b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb27b19",
  null
  
)

export default component.exports